/**
 * useHapticFeedback, best-effort haptic substitute for the web.
 *
 * The web doesn't have CoreHaptics like iOS does, but Android Chrome
 * (and some other mobile browsers) support `navigator.vibrate(ms)`,
 * which gives a subtle tactile cue.
 *
 * Usage: `haptic('light')` after a navigation tap, `haptic('medium')`
 * for confirms, `haptic('error')` for invalid input.
 *
 * On desktop / iOS Safari (no vibrate support), this no-ops silently , 
 * the CSS-based scale/translate micro-interactions on the buttons
 * already provide a visual substitute.
 */

const PATTERNS = {
  light:     [8],
  medium:    [14],
  heavy:     [22],
  selection: [4],
  success:   [12, 30, 12],
  warning:   [20, 50, 20],
  error:     [30, 60, 30, 60, 30],
};

export const haptic = (type = 'light') => {
  if (typeof window === 'undefined') return;
  if (typeof navigator === 'undefined') return;
  if (typeof navigator.vibrate !== 'function') return;
  try {
    navigator.vibrate(PATTERNS[type] || PATTERNS.light);
  } catch { /* unsupported */ }
};

export default haptic;
